module.exports = __webpack_public_path__ + "img/dlsl.773ca670.png";